const authorizationActions = {
		INIT: 'INIT',
		LOGIN: 'LOGIN',
		LOGOUT: 'LOGOUT'
};

export default authorizationActions;